import { render, staticRenderFns } from "./editPlate.vue?vue&type=template&id=10b6c34d&scoped=true&"
import script from "./editPlate.vue?vue&type=script&lang=js&"
export * from "./editPlate.vue?vue&type=script&lang=js&"
import style0 from "./editPlate.vue?vue&type=style&index=0&id=10b6c34d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6c34d",
  null
  
)

export default component.exports